import { VueConstructor } from 'vue/types/umd';
import { ElementType, SectionType } from '../model';
import HeadingComponent from '../components/Heading/HeadingRender.vue';
import TextComponent from '../components/Text/TextRender.vue';
import ButtonComponent from '../components/Button/ButtonRender.vue';
import ImageComponent from '../components/Image/ImageRender.vue';
import SurveyComponent from '../components/Survey/SurveyRender.vue';
import VideoComponent from '../components/Video/VideoRender.vue';
import FullWidthListSection from '../components/FullWidthList/FullWidthListRender.vue';

// TODO: Determine why "as VueConstructor" is needed everywhere...
export const COMPONENTS_BY_TYPE: Record<ElementType, VueConstructor> = {
	[ElementType.HEADING]: HeadingComponent as VueConstructor,
	[ElementType.TEXT]: TextComponent as VueConstructor,
	[ElementType.BUTTON]: ButtonComponent as VueConstructor,
	[ElementType.IMAGE]: ImageComponent as VueConstructor,
	[ElementType.SURVEY]: SurveyComponent as VueConstructor,
	[ElementType.VIDEO]: VideoComponent as VueConstructor,
};

export const SECTIONS_BY_TYPE: Record<SectionType, VueConstructor> = {
	[SectionType.FULL_WIDTH_LIST]: FullWidthListSection as VueConstructor,
};
